<template>

<fragment>

<div class="rule">

    <div class="rule-head">

        <div class="rule-name">{{ type.lang.name }}</div>

        <div class="rule-category">
            <span v-for="(category, index) in categories" :key="index" :data-name="category">{{ category }}</span>
            <span data-name="Optional" v-if="isOptional">Optional</span>
        </div>

        <div class="rule-description">{{ type.lang.description }}</div>

    </div>

    <div class="rule-toggle" :class="{'is-expanded': is.expanded}" v-if="isOptional" v-on:click="onToggleClick">

        <template v-if="!is.expanded">Click to configure</template>
        <template v-if="is.expanded">Click to cancel</template>

    </div>

    <template v-if="is.expanded">

        <div class="rule-settings">

            <com-setting-logic :type="type" v-model="model.setting.logic" v-if="type.setting.logic" />
            <com-setting-period :type="type" v-model="model.setting.period" v-if="type.setting.period" />
            <com-setting-range :type="type" v-model="model.setting.range" :logic="model.setting.logic" v-if="type.setting.range" />
            <com-setting-count :type="type" v-model="model.setting.count" :logic="model.setting.logic" v-if="type.setting.count" />
            <com-setting-rating :type="type" v-model="model.setting.rating" :logic="model.setting.logic" v-if="type.setting.rating" />

        </div>

        <com-logic-contains :type="type" :rule="model" v-model="model.logic" v-if="model.setting.logic === 'contains'" class="rule-logic" />
        <com-logic-min :type="type" :rule="model" v-model="model.logic" v-if="model.setting.logic === 'min'" class="rule-logic" />
        <com-logic-max :type="type" :rule="model" v-model="model.logic" v-if="model.setting.logic === 'max'" class="rule-logic" />
        <com-logic-one :type="type" :rule="model" v-model="model.logic" v-if="model.setting.logic === 'oneof'" class="rule-logic" />
        <com-logic-some :type="type" :rule="model" v-model="model.logic" v-if="model.setting.logic === 'someof'" class="rule-logic" />
        <com-logic-all :type="type" :rule="model" v-model="model.logic" v-if="model.setting.logic === 'allof'" class="rule-logic" />
        <com-logic-match :type="type" :rule="model" :categories="type.categories" v-model="model.logic" v-if="model.setting.logic === 'match'" class="rule-logic" />
        <com-logic-range :type="type" :rule="model" v-model="model.logic" v-if="model.setting.logic === 'range'" class="rule-logic" />
        <com-logic-tolerance :type="type" :rule="model" v-model="model.logic" v-if="model.setting.logic === 'tolerance'" class="rule-logic" />
        <com-logic-rolling :type="type" :rule="model" v-model="model.logic" v-if="model.setting.logic === 'rolling'" class="rule-logic" />

        <portal-target name="after" />

    </template>

</div>

</fragment>

</template>

<script>

import $filter from '@/filter'

import comSettingLogic from './Setting_Logic'
import comSettingPeriod from './Setting_Period'
import comSettingRange from './Setting_Range'
import comSettingCount from './Setting_Count'
import comSettingRating from './Setting_Rating'

import comLogicContains from './Logic_Contains'
import comLogicMin from './Logic_Min'
import comLogicMax from './Logic_Max'
import comLogicOne from './Logic_One'
import comLogicSome from './Logic_Some'
import comLogicAll from './Logic_All'
import comLogicMatch from './Logic_Match'
import comLogicRange from './Logic_Range'
import comLogicTolerance from './Logic_Tolerance'
import comLogicRolling from './Logic_Rolling'

export default {

    name: 'rule-filter',

    props: ['value'],
    
    components: {

        'com-setting-logic': comSettingLogic,
        'com-setting-period': comSettingPeriod,
        'com-setting-range': comSettingRange,
        'com-setting-count': comSettingCount,
        'com-setting-rating': comSettingRating,

        'com-logic-contains': comLogicContains,
        'com-logic-min': comLogicMin,
        'com-logic-max': comLogicMax,
        'com-logic-one': comLogicOne,
        'com-logic-some': comLogicSome,
        'com-logic-all': comLogicAll,
        'com-logic-match': comLogicMatch,
        'com-logic-range': comLogicRange,
        'com-logic-tolerance': comLogicTolerance,
        'com-logic-rolling': comLogicRolling

    },
    
    data: function() {

        return {
            is: {
                expanded: true,
                initialised: false
            },
            model: {
				type: '',
                setting: {
                    logic: ''
                },
                logic: {}
            }
        }

    },

    created: function() {

        if (this.value.setting) {

            this.model = this.$util.copy(this.value)

            this.$nextTick(function() {

                this.is.initialised = true

            }.bind(this))

        } else {

            this.is.initialised = true

            this.model.type = this.value.type

            if (this.type.usage.linkOnly) {

                this.is.expanded = false

            }

            if(this.type.default.logic) this.$vueset(this.model.setting, 'logic', this.type.default.logic)
            if(this.type.default.period) this.$vueset(this.model.setting, 'period', this.type.default.period)
            if(this.type.default.range) this.$vueset(this.model.setting, 'range', this.type.default.range)
            if(this.type.default.rating) this.$vueset(this.model.setting, 'rating', this.type.default.rating)
            if(this.type.default.count) this.$vueset(this.model.setting, 'count', this.type.default.count)
            if(this.type.default.value !== undefined) this.$vueset(this.model.logic, 'value', this.type.default.value)
            if(this.type.default.tolerance !== undefined) this.$vueset(this.model.logic, 'tolerance', this.type.default.tolerance)
            if(this.type.default.to !== undefined) this.$vueset(this.model.logic, 'to', this.type.default.to)

        }

    },

    watch: {

        model: {

            deep: true,

            handler: function() {

                this.emitModel()

            }
            
        },

        'is.expanded': function() {

            this.emitModel()

        }

    },

    computed: {

        isOptional: function() {

            return this.type.usage.linkOnly

        },

        categories: function() {

            return this.$_.isArray(this.type.lang.category) ? this.type.lang.category : [this.type.lang.category]

        },

        type: function() {

            return $filter.type[this.model.type]

        }

    },

    methods: {

        emitModel: function() {

            this.$emit('input', (this.is.expanded) ? this.$util.copy(this.model) : {
                type: this.model.type
            })

        },

        onToggleClick: function() {

            this.is.expanded = !this.is.expanded

        }

    }

}

</script>

<style scoped>

.rule {
    margin: 10px 10px 20px 10px;
    display: grid;
    grid-gap: 1px;
    grid-template-columns: 1fr;
}

.is-mobile .rule {
    grid-gap: 0px;
}

.rule:after {
    display: block;
    content: '';
    position: absolute;
    width: 2px;
    bottom: -20px;
    height: 20px;
    left: 50%;
    margin-left: -1px;
    background-color: #22465A;
}

.is-mobile .rule:after {
    background-color: #eee;
}

.rule-head {
    padding: 15px 10px 14px 10px;
    background-color: #22465A;
    border-radius: 10px 10px 0px 0px;
}

.is-mobile .rule-head {
    background-color: #fff;
    border: 1px solid #eee;
}

.rule-settings:empty + .rule-logic:empty + .rule-head,
.rule-head:has(+ .rule-settings:empty + .rule-logic:empty) {
    border-radius: 10px 10px 10px 10px;
}

.rule-name {
    font-size: 16px;
    color: #fff;
    text-align: center;
    font-weight: 500;
}

.is-mobile .rule-name {
    color: #343434;
}

.rule-description {
    font-size: 14px;
    line-height: 16px;
    margin-top: 8px;
    color: #fff;
    text-align: center;
    font-weight: 400;
    opacity: 0.8;
}

.is-mobile .rule-description {
    color: #343434;
}

.rule-settings {
    display: grid;
    background-color: #22465A;
    grid-template-columns: 1fr;
    justify-content: center;
    grid-gap: 4px;
    padding: 10px 10px;
}

.is-mobile .rule-settings {
    background-color: #fff;
    border: 1px solid #eee;
    border-top: 0px;
}

.rule-toggle {
    background-color: #22465A;
    grid-gap: 4px;
    border-radius: 0px 0px 4px 4px;
    text-align: center;
    padding: 10px 10px;
    cursor: pointer;
    font-size: 14px;
    user-select: none;
    font-weight: 500;
    color: #fff;
}

.is-mobile .rule-toggle {
    background-color: #fff;
    border: 1px solid #eee;
    border-top: 0px;
}

.rule-toggle.is-expanded {
    border-radius: 0px;
}

.rule-toggle:hover {
    background-color: #193443;
}

.rule-settings:empty {
    display: none;
}

.rule-value {
    padding: 15px 10px;
    background-color: #22465A;
    border-radius: 0px 0px 10px 10px;
}

.is-mobile .rule-value {
    background-color: #fff;
    border: 1px solid #eee;
    border-top: 0px;
}

.rule-category {
    display: flex;
    gap: 4px;
    justify-content: center;
    margin-top: 4px;
}

.rule-category span {
    font-weight: 500;
    line-height: 12px;
    font-size: 12px;
    border-radius: 4px;
    padding: 2px 4px;
    color: #0a2b3d;
}

.rule-category span[data-name="User"] {
    background-color: #E9C46A;
}

.rule-category span[data-name="Game"] {
    background-color: #CBA6F7;
}

.rule-category span[data-name="BGG"] {
    background-color: #6EC5E9;
}

.rule-category span[data-name="Plays"] {
    background-color: #E9A6A6;
}

.rule-category span[data-name="Collection"] {
    background-color: #90E0A9;
}

.rule-category span[data-name="Ratings"] {
    background-color: #E27B64;
}

.rule-category span[data-name="Optional"] {
    background-color: #A8B3C1;
}

</style>